import React, { useState, useEffect } from 'react'
import Header from './layout/Header'
import Footer from './layout/Footer'
import * as websiteService from './services/website.services'

const DEFAULT_FAQS = [
  {
    question: 'What is the mNetrics app?',
    answer: 'mNetrics is a digital scoring and analytics app for netball, designed to simplify in-game scorekeeping and team action capturing, while offering in-depth performance insights for players, coaches and parents/guardians.',
  },
  {
    question: 'Who is the app for?',
    answer: 'mNetrics is built for players, coaches, parents/guardians, schools, clubs, and teams that want better visibility into netball performance and match activity.',
  },
  {
    question: 'Does the app follow standard Netball rules?',
    answer: 'Yes, mNetrics is pre-configured with standard netball rules, but it also allows for customization in friendly or training matches.',
  },
  {
    question: 'How are turnovers captured?',
    answer: 'Turnovers can be captured in real-time by selecting the "Turnover" action during match recording, which will then prompt for the type and player involved.',
  },
  {
    question: 'How is my personal data protected?',
    answer: 'We use industry-standard encryption to protect your data. Your personal performance metrics are only visible to you and your authorized club administrators.',
  },
  {
    question: 'Can I request to delete my account and data?',
    answer: 'Yes, you can request full account deletion through the settings menu in the app, and all your personal data will be removed from our servers.',
  },
  {
    question: 'Can I use the app offline?',
    answer: 'Yes, you can record matches offline. The data will automatically sync with our servers once you are back online.',
  },
  {
    question: 'How do I start my first match?',
    answer: 'Simply navigate to the "Match" tab, select your team, and click "Start New Match" to begin capturing live stats.',
  }
]

export default function Faq() {
  const [faqs, setFaqs] = useState([])
  const [loading, setLoading] = useState(true)
  const [activeFaqIndex, setActiveFaqIndex] = useState(0)

  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const response = await websiteService.FAQList();
        if (response.success && response.data) {
          setFaqs(response.data);
        }
      } catch (error) {
        console.error("Failed to fetch FAQs", error);
      } finally {
        setLoading(false);
      }
    };
    fetchFaqs();
  }, []);

  const displayFaqs = faqs.length > 0 ? faqs : DEFAULT_FAQS;

  const handleFaqToggle = (index) => {
    setActiveFaqIndex((prevIndex) => (prevIndex === index ? -1 : index))
  }

  const renderAnswer = (answer) => {
    if (!answer) return null;
    const lines = answer.split(/\r?\n/).filter(line => line.trim() !== '')
    const hasNumberedItems = lines.some(line => /^\d+\./.test(line.trim()))
    
    if (hasNumberedItems && lines.length > 1) {
      return (
        <ul className='faq-answer-list'>
          {lines.map((line, idx) => (
            <li key={idx} className='faq-answer-item'>
              {line.trim()}
            </li>
          ))}
        </ul>
      )
    }
    
    if (lines.length > 1) {
      return (
        <>
          {lines.map((line, idx) => (
            <p key={idx} className='faq-answer'>
              {line.trim()}
            </p>
          ))}
        </>
      )
    }
    
    return <p className='faq-answer'>{answer}</p>
  }

  return (
    <React.Fragment>
      <Header />
      <main className="faq-page-content">
        <section className='faq_banner'>
          <div className='container'>
            <h1 className='faq-title text-center text-white'>Frequently Asked Questions</h1>
          </div>
        </section>

        <section className='faq_list padding-top-60 pb-5'>
          <div className='container'>
            <div className='faq-tabs-wrap'>
              {/* FAQ Accordion List */}
              <div className='faq-results'>
                {loading ? (
                  <div className='text-center py-5'>Loading FAQs...</div>
                ) : (
                  <div className='faq-accordion'>
                    {displayFaqs.length > 0 ? (
                      displayFaqs.map((item, index) => {
                        const isOpen = activeFaqIndex === index
                        return (
                          <article className={`faq-card ${isOpen ? 'open' : ''}`} key={index}>
                            <button
                              type='button'
                              className='faq-card-header'
                              onClick={() => handleFaqToggle(index)}
                            >
                              <span className='faq-card-question'>{item.question}</span>
                              <span className='faq-card-icon'>
                                {isOpen ? <i className="fa fa-minus"></i> : <i className="fa fa-plus"></i>}
                              </span>
                            </button>

                            {isOpen && (
                              <div className='faq-card-body'>
                                {renderAnswer(item.answer)}
                              </div>
                            )}
                          </article>
                        )
                      })
                    ) : (
                      <div className='text-muted py-4'>No questions found.</div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </React.Fragment>
  )
}
